import {
  VolleyballEventStatusId,
  VolleyballIncidentId,
} from '@collector/sportsapi-client-legacy'

import { ManualAddIncidentConfig } from '../../configuration'

export const manualAddIncidentConfig: ManualAddIncidentConfig<
  VolleyballIncidentId,
  VolleyballEventStatusId
> = {
  getKeyIncidents: () => [
    VolleyballIncidentId.ServiceAce,
    VolleyballIncidentId.AttackPoint,
    VolleyballIncidentId.BlockPoint,
    VolleyballIncidentId.Point,
    VolleyballIncidentId.ServiceError,
    VolleyballIncidentId.AttackError,
    VolleyballIncidentId.TechnicalErrors,
  ],
  otherIncidents: [
    VolleyballIncidentId.Serve,
    VolleyballIncidentId.NeutralAttack,
    VolleyballIncidentId.Dig,
    VolleyballIncidentId.Reception,
    VolleyballIncidentId.Set,
    VolleyballIncidentId.Cards,
  ],
  eventStatuses: [
    VolleyballEventStatusId.FirstSet,
    VolleyballEventStatusId.SecondSet,
    VolleyballEventStatusId.ThirdSet,
    VolleyballEventStatusId.FourthSet,
    VolleyballEventStatusId.FifthSet,
    VolleyballEventStatusId.GoldenSet,
  ],
  layouts: {
    otherIncidentsLayout: {
      containerClass: 'grid grid-flow-row grid-cols-3 gap-1',
      buttonClass: '@md:w-59!',
    },
    eventStatusesLayout: {
      containerClass: 'grid grid-flow-row grid-cols-3 gap-1',
      buttonClass: '@md:w-59!',
    },
  },
}
